import styled from "styled-components";

export const StyledChartContainer = styled.section`
  flex: 0 1 100vw;
  width: 100%;
  height: 640px;
  position: relative;
`;
